<template>
  <div class="flex flex-col items-center justify-center p-14 text-lg text-white">
    <div class="flex items-center justify-center">
      <fa class="mb-3 text-6xl" :icon="['fas', 'exclamation-triangle']" />
    </div>
    <div class="flex items-center justify-center uppercase">Error Loading Data</div>
  </div>
</template>
